// Layout.jsx
import { DashboardLayout } from '@toolpad/core/DashboardLayout'
import { Outlet, useLocation } from 'react-router-dom'

function Layout() {
	const location = useLocation()

	// Маршруты, где Sidebar (DashboardLayout) не должен отображаться
	const noSidebarRoutes = ['/login']
	const isSidebarHidden = noSidebarRoutes.includes(location.pathname)

	if (isSidebarHidden) {
		// Если Sidebar не нужен, рендерим только дочерние элементы
		return <Outlet />
	}

	return (
		<DashboardLayout>
			<Outlet />
		</DashboardLayout>
	)
}

export default Layout
